import { createContext, mergeProps, onCleanup, onMount, useContext, } from 'solid-js';
export const defaultContext = createContext(undefined);
const QueryClientSharingContext = createContext(false);
// If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if Solid Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function getQueryClientContext(context, contextSharing) {
    if (context) {
        return context;
    }
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.SolidQueryClientContext) {
            window.SolidQueryClientContext = defaultContext;
        }
        return window.SolidQueryClientContext;
    }
    return defaultContext;
}
export const useQueryClient = ({ context } = {}) => {
    const queryClient = useContext(getQueryClientContext(context, useContext(QueryClientSharingContext)));
    if (!queryClient) {
        throw new Error('No QueryClient set, use QueryClientProvider to set one');
    }
    return queryClient;
};
export const QueryClientProvider = (props) => {
    const mergedProps = mergeProps({
        contextSharing: false,
    }, props);
    onMount(() => {
        mergedProps.client.mount();
        if (process.env.NODE_ENV !== 'production' && mergedProps.contextSharing) {
            mergedProps.client
                .getLogger()
                .error(`The contextSharing option has been deprecated and will be removed in the next major version`);
        }
    });
    onCleanup(() => mergedProps.client.unmount());
    const QueryClientContext = getQueryClientContext(mergedProps.context, mergedProps.contextSharing);
    return (<QueryClientSharingContext.Provider value={!mergedProps.context && mergedProps.contextSharing}>
      <QueryClientContext.Provider value={mergedProps.client}>
        {mergedProps.children}
      </QueryClientContext.Provider>
    </QueryClientSharingContext.Provider>);
};
